import { Button, Radio, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import type { PreviewControlState } from './types';
import styles from './widget-preview.module.scss';

interface PreviewControlsProps {
  value: PreviewControlState;
  onChange: (value: PreviewControlState) => void;
  onReset: () => void;
  onClear: () => void;
}

export const PreviewControls = ({ value, onChange, onReset, onClear }: PreviewControlsProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'presets.editor.preview.controls',
  });
  const update = <Key extends keyof PreviewControlState>(
    key: Key,
    nextValue: PreviewControlState[Key],
  ) => onChange({ ...value, [key]: nextValue });

  return (
    <div className={styles.previewControls}>
      <Radio.Group
        value={value.device}
        size="small"
        optionType="button"
        buttonStyle="solid"
        options={[
          { label: t('desktop'), value: 'desktop' },
          { label: t('mobile'), value: 'mobile' },
        ]}
        onChange={(event) => update('device', event.target.value)}
      />
      <Radio.Group
        value={value.displayState}
        size="small"
        optionType="button"
        buttonStyle="solid"
        options={[
          { label: t('trigger'), value: 'trigger' },
          { label: t('welcome'), value: 'welcome' },
          { label: t('open'), value: 'open' },
        ]}
        onChange={(event) => update('displayState', event.target.value)}
      />
      <div className={styles.previewSwitches}>
        <label>
          <Switch
            size="small"
            checked={value.showContactForm}
            disabled={value.displayState !== 'open'}
            onChange={(checked) => update('showContactForm', checked)}
          />
          <span>{t('form')}</span>
        </label>
        <label>
          <Switch
            size="small"
            checked={value.showTyping}
            disabled={value.displayState !== 'open'}
            onChange={(checked) => update('showTyping', checked)}
          />
          <span>{t('typing')}</span>
        </label>
        <label>
          <Switch
            size="small"
            checked={value.showFormError}
            disabled={!value.showContactForm || value.displayState !== 'open'}
            onChange={(checked) => update('showFormError', checked)}
          />
          <span>{t('formError')}</span>
        </label>
      </div>
      <div className={styles.previewActions}>
        <Button size="small" onClick={onReset}>
          {t('reset')}
        </Button>
        <Button size="small" onClick={onClear}>
          {t('clear')}
        </Button>
      </div>
    </div>
  );
};
